let suppressedAnalyticsTrackingDepth = 0

type NonPromise<T> = T extends PromiseLike<unknown> ? never : T


export const withAnalyticsTrackingSuppressed = <T>(
  callback: () => NonPromise<T>
): NonPromise<T> => {
  suppressedAnalyticsTrackingDepth += 1

  try {
    return callback()
  } finally {
    suppressedAnalyticsTrackingDepth -= 1
  }
}

export const isAnalyticsTrackingSuppressed = () => {
  return suppressedAnalyticsTrackingDepth > 0
}
